import { ReaderNameSchema } from "@bindery/shared/contracts/session";
import * as z from "zod";

export const SESSION_PATH = "/api/session";

// `readers` is the broker's `readerNames` roster, which already holds every
// reader the adult linked as "Teacher" and never a class roster's readers.
// `boundReader` is the reader the session was minted for, which the broker
// stamps only for a reader on that roster.
export const sessionAnswerSchema = z.object({
  boundReader: ReaderNameSchema.nullable(),
  readers: z.array(ReaderNameSchema),
});

export type SessionAnswer = z.infer<typeof sessionAnswerSchema>;

export const SESSION_REFUSALS = {
  unauthenticated: 401,
  forbidden: 403,
} as const;

export type SessionRefusal = keyof typeof SESSION_REFUSALS;
